import type { AppRouteGroup } from 'app/store/components/NavigationUtils';

import LoginPage from './LoginPage';

const routes: AppRouteGroup = {
	settings: {
		layout: {
			style: 'layout1',
			config: {
				navbar: { display: false },
				toolbar: { display: false },
				footer: { display: false },
				leftSidePanel: { display: false },
				rightSidePanel: { display: false }
			}
		}
	},
	routes: [
		{
			path: 'login',
			auth: null,
			element: <LoginPage />
		}
	]
};

export default routes;
